import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import media from 'styled-media-query'
import CarouselArrow from '@/components/atoms/CarouselArrow/CarouselArrow'

const SLIDE_IMAGE_WIDTH = 350
const SLIDE_IMAGE_HEIGHT = 240

const Container = styled.div`
  position: relative;
  width: 100%;
`

const Slider = styled.div`
  display: flex;

  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  scroll-behavior: smooth;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  scroll-snap-type: x mandatory;

  ${media.greaterThan('medium')`
    gap: 8px;
    padding: 0px 16px;

    scroll-snap-type: unset;
  `}
`

const Slide = styled.div`
  position: relative;

  flex: none;
  width: 100%;
  height: 264px;
  aspect-ratio: ${SLIDE_IMAGE_WIDTH} / ${SLIDE_IMAGE_HEIGHT};

  scroll-snap-align: start;

  ${media.greaterThan('medium')`
    width: 300px;
    height: auto;
    overflow: hidden;
    border-radius: 10px;
  `}
`

const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const OverlayButton = styled.a`
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  background: linear-gradient(
    0deg,
    rgba(19, 19, 19, 0.53),
    rgba(19, 19, 19, 0.53)
  );

  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const MoreButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 148px;
  height: 42px;
  background: rgba(38, 36, 36, 0.76);
  border: 1px solid #ffffff;
  color: white;
  border-radius: 6px;
  cursor: pointer;
`

const SLIDES_COUNT = 5

function getSlideImageURL(slide, width, height) {
  return `https://res.cloudinary.com/rehabpath/image/upload/e_gen_restore/c_fill,w_${width},h_${height},q_15/f_auto/${slide.id
    .split('/')
    .pop()}`
}

const CenterCardSlider = (props) => {
  const slides = props.slides.slice(0, SLIDES_COUNT).map((slide, index) => {
    return {
      position: index,
      id: slide
    }
  })

  const sliderRef = useRef()

  const nextSlide = () => {
    sliderRef.current.scrollBy(300, 0)
  }
  const prevSlide = () => {
    sliderRef.current.scrollBy(-300, 0)
  }
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(true)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  return (
    <Container>
      <Slider
        onScroll={(e) => {
          // Show/hide arrows based on the scroll position
          setShowLeftArrow(e.currentTarget.scrollLeft > 0)
          setShowRightArrow(
            e.currentTarget.clientWidth + e.currentTarget.scrollLeft <
              e.currentTarget.scrollWidth
          )

          // Show/hide current slide indicator based on the scroll position
          setCurrentSlideIndex(
            Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth)
          )
        }}
        ref={sliderRef}
      >
        {slides.map((slide, index) => {
          return (
            <Slide
              order={slide.position}
              key={slide.id}
            >
              <SlideImage
                src={getSlideImageURL(
                  slide,
                  SLIDE_IMAGE_WIDTH,
                  SLIDE_IMAGE_HEIGHT
                )}
                srcSet={[
                  `${getSlideImageURL(
                    slide,
                    SLIDE_IMAGE_WIDTH * 2,
                    SLIDE_IMAGE_HEIGHT * 2
                  )} ${SLIDE_IMAGE_WIDTH * 2}w`,
                  `${getSlideImageURL(
                    slide,
                    SLIDE_IMAGE_WIDTH * 3,
                    SLIDE_IMAGE_HEIGHT * 3
                  )} ${SLIDE_IMAGE_WIDTH * 3}w`,
                  `${getSlideImageURL(
                    slide,
                    SLIDE_IMAGE_WIDTH * 4,
                    SLIDE_IMAGE_HEIGHT * 4
                  )} ${SLIDE_IMAGE_WIDTH * 4}w`
                ].join(', ')}
                sizes={`(min-width: 768px) 300px, 100vw`}
                loading="lazy"
              />
              {index === 4 && (
                // Wrapping a nested link with an object – as a hack
                // to allow nested links in HTML. See https://kizu.dev/nested-links/
                <object>
                  <OverlayButton
                    href={`/${props.slug}/#profile-photos`}
                    target="_blank"
                  >
                    <MoreButton>More Photos</MoreButton>
                  </OverlayButton>
                </object>
              )}
            </Slide>
          )
        })}
      </Slider>
      {showRightArrow && (
        <CarouselArrow
          size="lg"
          direction="right"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            nextSlide()
          }}
        />
      )}

      {showLeftArrow && (
        <CarouselArrow
          size="lg"
          direction="left"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            prevSlide()
          }}
        />
      )}
      <div className="pointer-events-none absolute top-0 size-full bg-gradient-to-b from-black/0 from-75% to-black/50 md:hidden"></div>
      <div className="absolute inset-x-0 bottom-4 flex justify-center md:hidden">
        {new Array(SLIDES_COUNT).fill(0).map((_, index) => {
          return (
            <div
              key={index}
              className={`mx-1 size-2 rounded-full ${
                index === currentSlideIndex ? 'bg-white' : 'bg-white/50'
              }`}
            ></div>
          )
        })}
      </div>
    </Container>
  )
}

export default CenterCardSlider
